<template lang="pug">
    div
        // 注意, 此組件會自動將 ["A", "B"] 轉換為 [{label: "A"}, {label: "B"}]
        // 所以判斷是不是object選項就是用 v-if="option.value"
        template(v-if="withOptionGroup")
            template(v-if="option.value")
                // span A 選項有分組, 且選項為 object 數組
                template(v-if="option.optionGroupName")
                    span.select-group-title {{option.optionGroupName}}
                template(v-else)
                    span.select-with-group {{ option.label }}
                    span(v-if="option.description" style="float: right; color: rgb(204, 204, 204)") {{ option.label }}
            template(v-else)
                // span B  選項有分組, 且選項為 value 數組
                template(v-if="option.optionGroupName")
                    span.select-group-title {{option.optionGroupName}}
                template(v-else)
                    span.select-with-group {{ option.label }}
        template(v-else)
            template(v-if="option.value")
                // span C 選項無分組, 且選項為 object 數組
                span {{ option.label }}
                span(v-if="option.description" style="float: right; color: rgb(204, 204, 204)") {{ option.description }}
            template(v-else)
                // span D 選項無分組, 且選項為 value 數組
                span {{ option.label }}
</template>
<script>
export default {
    props: {
        withOptionGroup: {},
        option: {},
    },
    watch: {},
    data() {
        return {};
    },
    methods: {},
    mounted() {},
    created() {},
    computed: {}
};
</script>
<style>
.select-group-title {
    font-size: 14px;
    color: #999;
    height: 30px;
    line-height: 30px;
}
.select-with-group {
    padding-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/Select/Options.vue